import { filtersHelper } from '@/utils';
import { orientationModuleHeaderModel } from '@/models/api/orientationModuleHeader.model';
import { orientationModuleModel } from '@/models/api/orientationModule.model';

export const orientationModuleGroupModel = (data) => ({
    uuid: data.uuid,
    sequence: data.sequence,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    header: data.header ? (orientationModuleHeaderModel(data.header)) : null,
    modules: (data.modules ?? []).map(item => (orientationModuleModel(item))),
});